import { render, staticRenderFns } from "./MyDialog.vue?vue&type=template&id=0a9bf47e&scoped=true"
import script from "./MyDialog.vue?vue&type=script&lang=js"
export * from "./MyDialog.vue?vue&type=script&lang=js"
import style0 from "./MyDialog.vue?vue&type=style&index=0&id=0a9bf47e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9bf47e",
  null
  
)

export default component.exports